export const conversationalWorkflows = "/:app_group_id/conversational/workflows";
